module.exports = __webpack_public_path__ + "img/default-avatar.c3e720f6.png";